import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { formatNumbersInHtml } from '../utils/number-format';

@Pipe({
  name: 'formatNumbersHtml',
  standalone: true,
})
export class FormatNumbersHtmlPipe implements PipeTransform {
  constructor(private readonly _sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml | string {
    if (value == null) {
      return '';
    }

    const formattedHtml = formatNumbersInHtml(value);
    return this._sanitizer.bypassSecurityTrustHtml(formattedHtml);
  }
}
